import ReactGA from 'react-ga4';
import { isAndWebView, isIOSWebView, IS_MARTGO_APP } from './constants';
import { IS_PROD } from './constants';
import { isMobile } from 'react-device-detect';

const deviceFgName = IS_MARTGO_APP ? 'APP' : isMobile ? 'WEB' : 'PC';

/**
 * @description 전단 GA 태깅 - 페이지뷰
 * @param pathname location.pathname
 * @param vName 페이지명 (각 페이지에서 호출 시 필수)
 * @description 브릿지로 전송해서 firebase에도 데이터 수집
 */
export const leafletGaPageView = (pageName: string, pathname: string): void => {
  setTimeout(() => {
    ReactGA.send({
      hitType: 'pageview',
      title: `[${deviceFgName} 스마트전단] ${pageName}`,
      page: pathname,
    });
  }, 150);
  if (IS_PROD) {
    try {
      if (isIOSWebView) {
        webkit.messageHandlers.sendFaView.postMessage({
          vId: '',
          vName: pageName,
        });
      } else if (isAndWebView) {
        window.binder?.sendFaView('', pageName);
      }
    } catch (e) {
      console.log(e);
    }
  }
};

/**
 * @description 전단 GA 태깅 - 이벤트
 * @param pageName 페이지 명
 * @param eName 이벤트 명
 */
export const leafletGaEvent = (pageName, eName): void => {
  ReactGA.event({
    action: `[스마트전단] ${eName} 클릭`,
    category: `${deviceFgName} ${pageName}`,
    label: eName,
  });

  if (IS_PROD) {
    try {
      if (isIOSWebView) {
        webkit.messageHandlers.sendFaEvent.postMessage({
          eId: '',
          eName: eName,
          eCate: `${deviceFgName} ${pageName}`,
          eType: '',
        });
      } else if (isAndWebView) {
        window.binder?.sendFaEvent('', eName, pageName, '');
      }
    } catch (e) {
      console.log(e);
    }
  }
};
